module.exports = __webpack_public_path__ + "8def2f91c7368f809e735025db570d89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/18.jpg
// module id = 1344
// module chunks = 47